import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Copy, X, Tag } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const endLabel = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "long" });

export default function PromoBanner() {
  const { user } = useAuth();
  const [promo, setPromo] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => { api.get("/promo-banner").then((r) => setPromo(r.data)).catch(() => {}); }, []);

  if (!promo || hidden) return null;
  if (user && user.subscription_tier && user.subscription_tier !== "free") return null;
  const key = `rf_promo_dismissed_${promo.code}`;
  if (localStorage.getItem(key)) return null;

  const copy = async () => {
    try { await navigator.clipboard.writeText(promo.code); toast.success(`Copied ${promo.code}`); } catch { /* ignore */ }
  };
  const close = () => { localStorage.setItem(key, "1"); setHidden(true); };

  return (
    <div className="bg-rf-ink text-white text-sm" data-testid="promo-banner" role="region" aria-label="Current promotion">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
        <Tag size={16} weight="fill" className="text-rf-amber" />
        <span data-testid="promo-banner-message">
          {promo.message || (promo.all_plans === false ? `Up to ${promo.percent_off}% off` : `${promo.percent_off}% off any plan`)}
          {promo.ends_on && <span className="text-white/70"> · ends {endLabel(promo.ends_on)}</span>}
        </span>
        <button type="button" onClick={copy} data-testid="promo-banner-copy"
                className="inline-flex items-center gap-1 font-mono font-bold bg-white/10 hover:bg-white/20 rounded-full px-3 py-0.5 transition-colors">
          {promo.code} <Copy size={12} />
        </button>
        <Link to={`/pricing?code=${encodeURIComponent(promo.code)}`} data-testid="promo-banner-link" className="font-bold text-rf-amber underline">
          See plans →
        </Link>
        <button type="button" onClick={close} aria-label="Close promotion banner" data-testid="promo-banner-close"
                className="ml-1 p-1 rounded-full hover:bg-white/10"><X size={14} /></button>
      </div>
    </div>
  );
}
